// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".voice-control[data-v-76af12b9]{width:28px;height:28px;display:flex;justify-content:center;align-items:center;flex-shrink:0;border-radius:50%;border:1px solid #ccc}.voice-control svg[data-v-76af12b9]{width:16px;height:auto;flex-shrink:0}", ""]);
// Exports
module.exports = exports;
